import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "58c27bda-7ff0-4ab4-aea6-e5c2f7505fa2",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "text",
    prefixText: "Input the directivity type (one word):",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: "cardioid",
};
